const GOL = (p) => {
  let columns;
  let rows;
  let board;
  let next;

  const widthPercentage = 1;
  const w = 10;

  const rawHeight = p.windowHeight * 4 / 10;
  const height = Math.floor(rawHeight / w) * w;
  
  const fullCell = p.color(237, 66, 51);
  const emptyCell = p.color(234, 233, 229);

  const createArray = () => {
    const newArray = new Array(columns);
    for (let i = 0; i < columns; i++) {
      newArray[i] = new Array(rows);
    }
    return newArray;
  };

  let lastHoverX = -1;
  let lastHoverY = -1;

  const activateBlockAroundMouse = (size = 1) => {
    const i = Math.floor(p.mouseX / w);
    const j = Math.floor(p.mouseY / w);

    // Only trigger if we moved to a new cell
    if (i === lastHoverX && j === lastHoverY) return;
    lastHoverX = i;
    lastHoverY = j;

    for (let dx = -size; dx <= size; dx++) {
      for (let dy = -size; dy <= size; dy++) {
        const x = i + dx;
        const y = j + dy;
        if (x >= 0 && x < columns && y >= 0 && y < rows) {
          board[x][y] = 1;
        }
      }
    }
  };
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  p.mouseMoved = () => {
    if (!isMobile) {
      activateBlockAroundMouse(1);
    }
  };
  
  p.touchStarted = () => {
    if (isMobile && p.mouseX >= 0 && p.mouseX < p.width && p.mouseY >= 0 && p.mouseY < p.height) {
      activateBlockAroundMouse(1);
      return false; // This tells p5 to prevent default scroll behaviour
    }
  };
  
  p.touchMoved = () => {
    if (isMobile && p.mouseX >= 0 && p.mouseX < p.width && p.mouseY >= 0 && p.mouseY < p.height) {
      activateBlockAroundMouse(1);
      return false;
    }
  };
  


p.setup = () => {
  p.frameRate(4);

  const rawWidth = p.windowWidth * widthPercentage;
  const adjustedWidth = Math.floor(rawWidth / w) * w;
  const c = p.createCanvas(adjustedWidth, height);

  columns = p.floor(p.width / w);
  rows = p.floor(p.height / w);

  board = createArray();
  next = createArray();

  p.strokeWeight(0);
  p.init();

  c.mousePressed(() => p.init());
};
  
  p.draw = () => {
    p.generate();

    for (let i = 0; i < columns; i++) {
      const thisCol = board[i];
      for (let j = 0; j < rows; j++) {
        p.fill(thisCol[j] === 1 ? fullCell : emptyCell);
        p.rect(i * w, j * w, w, w);
      }
    }

    // uncomment to Show FPS
    // p.fill(0);
    // p.noStroke();
    // p.textSize(12);
    // p.text(`FPS: ${p.frameRate().toFixed(1)}`, 10, 20);
  };

  p.init = () => {
    for (let i = 0; i < columns; i++) {
      for (let j = 0; j < rows; j++) {
        board[i][j] = p.random() < 0.15 ? 1 : 0;
      }
    }
  };
  

  p.windowResized = () => {
    p.setup();
  };

  p.generate = () => {
    for (let x = 0; x < columns; x++) {
      for (let y = 0; y < rows; y++) {
        let neighbours = 0;
  
        for (let i = -1; i <= 1; i++) {
          for (let j = -1; j <= 1; j++) {
            const col = (x + i + columns) % columns;
            const row = (y + j + rows) % rows;
            neighbours += board[col][row];
          }
        }
  
        neighbours -= board[x][y]; // Subtract self
  
        const isAlive = board[x][y] === 1;
        if (isAlive && neighbours < 2) next[x][y] = 0;
        else if (isAlive && neighbours > 3) next[x][y] = 0;
        else if (!isAlive && neighbours === 3) next[x][y] = 1;
        else next[x][y] = board[x][y];
      }
    }
  
    // Swap buffers
    const temp = board;
    board = next;
    next = temp;
  };
};

export default GOL;
